import { api } from '../../core/network/api';

export interface KycSubmitFields {
  fullName: string;
  dateOfBirth: string;
  address: string;
  country: string;
  document: File;
}

/** Matches core's 10 MB `FileInterceptor` limit, checked before we upload. */
export const KYC_MAX_FILE_BYTES = 10 * 1024 * 1024;

/**
 * Submit a KYC application.
 *
 * THE HEADER IS LOAD-BEARING. The shared axios client sets
 * `Content-Type: application/json` as an instance default
 * (`core/network/api.ts`), and axios's `transformRequest` JSON-stringifies a
 * FormData body whenever the content type says JSON — the file would be
 * silently dropped and the server would answer "Document file is required".
 * Naming multipart here makes axios pass the FormData through untouched; the
 * xhr adapter then clears the header so the browser can add its own boundary.
 * `core/` is template-owned, so this is fixed at the call site.
 */
export function submitKyc(fields: KycSubmitFields): Promise<{ status: string }> {
  const form = new FormData();
  form.append('fullName', fields.fullName);
  form.append('dateOfBirth', fields.dateOfBirth);
  form.append('address', fields.address);
  form.append('country', fields.country);
  form.append('document', fields.document);

  return api.post<{ status: string }>('/kyc/submit', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
